export default "__VITE_ASSET__DtYhz6wj__"